import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { callHistoryByPhone } from '../../redux/slices/callCollectionSlice';
import BasicTableOne from '../../components/table/BasicTable';
import moment from 'moment';
import Models from '../../components/common/Models';
import { toast } from 'react-toastify';
import axiosInstance from '../../services/axios';
import CallNotes from './CallNotes';
import { useLocation } from 'react-router-dom';

export default function EmployeeCallDetails({id}) {
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = React.useState(0);
    const [open, setOpen] = React.useState(false);
     const [currentRow, setCurrentRow] = useState(null);
    const [notesData, setNotesData] = useState([]);
    const [tableRow, setTableRow] = React.useState([]);
  const { data = [], loading: loading } = useSelector(
    (state) => state?.callCollections || []
  );
  useEffect(() => {
    if(id){
        console.log(id)
        dispatch(callHistoryByPhone({ id: id }));
    }
  }, [dispatch, id]);
     const callTypes = [
    {id:0,name:"All",value:"ALL"},
    {id:1,name:"Incoming",value:"INCOMING"},
    {id:2,name:"Outgoing",value:"OUTGOING"},
    {id:3,name:"Missed",value:"MISSED"},
  ]
  const location = useLocation();
  let isAdmin  = false;
  if(location.pathname.includes('admin')){
    isAdmin = true;
  }
  const tableColumns = [
          { id: "id", label: "#", type: "text" },
          { id: "phone", label: "Phone", type: "text" },
          { id: "date", label: "Date", type: "text" },
          { id: "time", label: "Time", type: "text" },        
          { id: "callType", label: "Call Type", type: "text" },
          { id: "duration", label: "Duration", type: "text" },
          isAdmin === false &&
           {
            id: "action",
            label: "Action",
            type: "action",
            actions: [{id:"addNotes",name:"Remarks",className:"w-[120px] bg-orange-700 text-white"}],
          }, // Placeholder for actions column
          
         
        
  ]
  const handleCloseModal = () => {
      setOpen(false);
    };

  
  useEffect(()=>{
    // Ensure data is an array before filtering
    const dataArray = Array.isArray(data) ? data : [];
    let newData = [];
    if(dataArray.length > 0){
      dataArray.forEach((item, index) => {
        newData.push({
           uuid:item.id,
          id: index + 1,
          phone: item.callName ?? item.number,
          date: (() => {
                        const callDate = moment(Number(item.callTimeStamp));
                        const today = moment();
                        const yesterday = moment().subtract(1, 'day');
                        
                        if (callDate.isSame(today, 'day')) {
                          return 'Today';
                        } else if (callDate.isSame(yesterday, 'day')) {
                          return 'Yesterday';
                        } else {
                          return callDate.format('YYYY-MM-DD');
                        }
                      })(),
          time: moment(Number(item.callTimeStamp)).format('HH:mm:ss A'),
          callType: item.callType,
          duration: moment.utc(item.callDuration * 1000).format('HH:mm:ss'),
        });
      });
    }
    if(activeTab === 0){
       setTableRow(newData);
    }else if(activeTab === 1){
      setTableRow(newData.filter(item => item.callType === "INCOMING"));
    }else if(activeTab === 2){
      setTableRow(newData.filter(item => item.callType === "OUTGOING"));
    }
    else if(activeTab === 3){
      setTableRow(newData.filter(item => item.callType === "MISSED"));
    }
  },[activeTab, data])
  const handleTableAction = (action, row)=>{
console.log("Action:", action, "Row:", row);
        switch (action) {
              case 'Remarks':
              setCurrentRow(row);
              setNotesData(data.length === 0 ? [] : data?.filter((item)=>item.id === row?.uuid)[0].callCollectionDetails);
              setOpen(true);

              break;
            default:
           console.log("Unhandled action:", action);
        }
  }
  console.log('Raw data:', data)
  console.log('Table rows after filtering:', tableRow)
  return (
    <>
      <div className='mt-4 bg-gray-200 dark:bg-gray-800 py-2 px-4 rounded-lg flex justify-start items-center'>
        {
        callTypes.map((item)=>(
          <button
            key={item.id}
            className={`px-4 py-2 rounded-lg ${activeTab === item.id ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'}`}
            onClick={() => setActiveTab(item.id)}
          >
            {item.name}
          </button>
        ))
      }
      </div>
      <div>
         <BasicTableOne
                           tableColumns={tableColumns}
                           handleTableAction={handleTableAction}  
                          tableRows={tableRow}
                           title=""
                           loading={loading}
                         />
      </div>

      <Models isOpen={open} isClose={handleCloseModal} name={"Call Notes"} >
                  {/* Add your form or content for adding a new admin here */}
                 <CallNotes id={currentRow} notes={notesData} />
              </Models>
    </>
  )
}
